import { motion } from 'framer-motion';

import { DARK_BG } from '../constants';

export function SpeedBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' style={{ zIndex: 0 }}>
      <div className='absolute inset-0' style={{ background: DARK_BG }} />
      {Array.from({ length: 15 }).map((_, i) => (
        <motion.div key={`speed-${i}`} className='absolute' style={{ top: `${(i * 13.7) % 100}%`, left: 0, width: 80 + (i % 5) * 50, height: 1, background: 'linear-gradient(to right, transparent, #ffffff06, transparent)' }} animate={{ x: ['-100vw', '120vw'] }} transition={{ duration: 2 + (i % 5) * 1, delay: (i % 8) * 0.7, repeat: Infinity, ease: 'linear' as const }} />
      ))}
    </div>
  );
}
